import { AuditLogListing } from 'components/Listing/AuditLog'
import React, { lazy } from 'react'

const GeneralPRMain = lazy(() =>
  import(
    '@account-root/procurement-react/src/containers/GeneralPurchaseModule/GeneralPRModule/GeneralPRMain'
  ).then(module => ({
    default: module.GeneralPRMain,
  }))
)

const PDFPreviewGP = lazy(() =>
  import(
    '@account-root/procurement-react/src/components/PDFTemplate/PDFPreviewGP'
  ).then(module => ({
    default: module.PDFPreviewGP,
  }))
)

const GeneralPRListing = lazy(() =>
  import(
    '@account-root/procurement-react/src/containers/GeneralPurchaseModule/GeneralPRModule/GeneralPRListing'
  ).then(module => ({
    default: module.GeneralPRListing,
  }))
)

const GeneralPRForm = lazy(() =>
  import(
    '@account-root/procurement-react/src/containers/GeneralPurchaseModule/GeneralPRModule/GeneralPRFormv2'
  ).then(module => ({
    default: module.PurchaseRequisitionForm,
  }))
)

const GeneralPRItemForm = lazy(() =>
  import(
    '@account-root/procurement-react/src/containers/GeneralPurchaseModule/GeneralPRModule/GeneralPRItemForm'
  ).then(module => ({
    default: module.PurchaseRequisitionItemForm,
  }))
)

const GeneralPRDetail = lazy(() =>
  import(
    '@account-root/procurement-react/src/containers/GeneralPurchaseModule/GeneralPRModule/GeneralPRDetail'
  ).then(module => ({
    default: module.GeneralPRDetail,
  }))
)

const generalPRRoutes = [
  {
    props: {
      exact: true,
      path: '/general-purchase/:CompanyID/purchase-requisition',
    },
    component: <GeneralPRMain />,
  },
  {
    props: {
      exact: true,
      path:
        '/general-purchase/:CompanyID/purchase-requisition/:PRHeaderID/preview',
    },
    component: (
      <PDFPreviewGP
        accountType="/"
        docType="purchase-requisition"
        backPath="purchase-requisition"
      />
    ),
  },
  {
    props: {
      exact: true,
      path: '/general-purchase/:CompanyID/purchase-requisition',
    },
    component: <GeneralPRListing />,
  },
  {
    props: {
      exact: true,
      path: '/general-purchase/:CompanyID/purchase-requisition/add',
    },
    component: <GeneralPRForm formMode="add" />,
  },
  {
    props: {
      exact: true,
      path:
        '/general-purchase/:CompanyID/purchase-requisition/:PRHeaderID/edit',
    },
    component: <GeneralPRForm formMode="edit" />,
  },
  {
    props: {
      exact: true,
      path:
        '/general-purchase/:CompanyID/purchase-requisition/:PRHeaderID/submit',
    },
    component: <GeneralPRForm formMode="submit" />,
  },
  {
    props: {
      exact: true,
      path: '/general-purchase/:CompanyID/purchase-requisition/add/preview',
    },
    component: <GeneralPRForm formMode="submit" />,
  },
  {
    props: {
      exact: true,
      path: '/general-purchase/:CompanyID/purchase-requisition/:PRHeaderID',
    },
    component: <GeneralPRDetail />,
  },
  {
    props: {
      exact: true,
      path:
        '/general-purchase/:CompanyID/purchase-requisition/:formMode/purchase-requisition-item/:detailMode',
    },
    component: <GeneralPRItemForm />,
  },
  //payment = add , paymentitem = edit & add
  {
    props: {
      exact: true,
      path:
        '/general-purchase/:CompanyID/purchase-requisition/:PRHeaderID/:formMode/purchase-requisition-item/:detailMode',
    },
    component: <GeneralPRItemForm />,
  },
  //payment = add, paymentitem = edit
  {
    props: {
      exact: true,
      path:
        '/general-purchase/:CompanyID/purchase-requisition/:formMode/purchase-requisition-item/:PRItemID/:detailMode',
    },
    component: <GeneralPRItemForm />,
  },
  //payment = edit, paymentitem = edit
  {
    props: {
      exact: true,
      path:
        '/general-purchase/:CompanyID/purchase-requisition/:PRHeaderID/:formMode/purchase-requisition-item/:PRItemID/:detailMode',
    },
    component: <GeneralPRItemForm />,
  },

  /* -------------------------------------------- */
  /*                AUDIT LOG                     */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path:
        '/general-purchase/:CompanyID/purchase-requisition/:PRHeaderID/audit-log',
    },
    component: (
      <AuditLogListing
        module="general-purchase"
        routeSegments="Purchase Requisition"
        smTitle="General Purchases"
        docType="purchase-requisition"
      />
    ),
  },
]

export default generalPRRoutes
